import React, { CSSProperties, useEffect, useState } from 'react'
import styles from './List.module.css'
import { useTranslation } from 'react-i18next'
import { Box } from '@mui/material'
import dayjs from 'dayjs'
import { capitalize } from '../../common/utils/strings'
import rightArrow from '../../assets/left_menu/ico-arrow-view.svg'
import { EventService } from '../../modules/calendar/services/EventService'
import { EVENT_SERVICE_KEY } from '../../modules/calendar'
import { UserFormService } from '../../modules/forms/services/UserFormService'
import { USER_FORM_SERVICE_KEY } from '../../modules/forms'
import { getFormContainer } from '../../container/form-module'
import { getCalendarContainer } from '../../container/calendar-module'
import { eventType, EventType } from '../../modules/notifications/enums/EventType'
import { ROUTE_ARTICLES, ROUTE_RESOURCES } from '../../routes/routes-constants'
import { useNavigate } from 'react-router-dom'
import { useCircleContext } from 'common/context/CircleContext'
import { ActivityWidgetIcon } from './ActivityWidgetIcon'
import { SendingStatus } from 'modules/notifications/enums/SendingStatus'

const calendarContainer = getCalendarContainer()
const eventService = calendarContainer.get<EventService>(EVENT_SERVICE_KEY)
const formContainer = getFormContainer()
const userFormService = formContainer.get<UserFormService>(USER_FORM_SERVICE_KEY)

export type ActivityWidgetProps = {
  id: string | undefined
  source: EventType
  title: string
  description?: string
  date: Date
  creator?: string
  url: string
  status?: SendingStatus
}

export function ActivityWidget(props: ActivityWidgetProps): JSX.Element {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { circle } = useCircleContext()

  const [status, setStatus] = useState<string>('')
  const [statusStyle, setStatusStyle] = useState<CSSProperties>()

  const patientName = circle?.patient?.firstName || 'Sin seleccionar'

  const handleOnClick = () => {
    switch (props.source) {
      case EventType.ArticlePublished:
      case EventType.ArticleUpdated:
        navigate(`${ROUTE_ARTICLES}/${props.url}`)
        break
      case EventType.ResourceShared:
      case EventType.ResourceUpdated:
        navigate(ROUTE_RESOURCES)
        break
      case EventType.CalendarEventCreated:
      case EventType.CalendarEventReminder:
        // TODO: Handle calendar event navigation
        break
      default:
        // TODO: Handle other event types if needed
        break
    }
  }

  useEffect(() => {
    if (props.status == SendingStatus.Pending) {
      setStatus('pending')
      setStatusStyle({
        margin: '0 0 2px 10px',
        padding: '5px 50px 5px 5px',
        backgroundColor: 'rgba(219,83,83,0.11)',
        color: '#BB3D3D',
        fontWeight: 'normal',
      })
      return
    }
    setStatus('completed')
    setStatusStyle({
      margin: '0 0 2px 10px',
      padding: '5px 50px 5px 5px',
      backgroundColor: 'rgba(83,219,90,0.11)',
      color: '#10A64A',
      fontWeight: 'normal',
    })
  }, [])

  return (
    <>
      <Box display={'flex'} flexDirection={'column'}>
        <Box display={'flex'} flexDirection={'row'}>
          <Box className={styles.notificationBox}>
            <Box display={'flex'} flexDirection={'row'} margin={'0 0 5px 10px'} padding={'5px'}>
              <ActivityWidgetIcon type={props.source} />
              <h2 style={{ color: '#a9ba37', margin: '0 0 0 5px', padding: '0', fontSize: 20 }}>
                {t(eventType()[props.source])}
              </h2>
            </Box>
            <Box display={'flex'} flexDirection={'column'}>
              <h2 style={{ margin: '0 0 5px 10px', padding: '0', fontSize: 20 }}>{props.title}</h2>
            </Box>
            <Box display={'flex'} flexDirection={'column'}>
              <h4 style={{ margin: '0 0 0 10px', padding: '0' }}>{patientName}</h4>{' '}
              <h4 style={{ margin: '0 0 2px 10px', padding: '0' }}>
                {capitalize(dayjs(props.date).locale('es').format('dddd, DD MMMM YYYY'))}
              </h4>
            </Box>
            <Box className={styles.containerFooter} style={{ justifyContent: 'space-between' }}>
              <Box>
                <h4 style={statusStyle}>{t(status)}</h4>
              </Box>
              <Box
                style={{ margin: '0', padding: '0', cursor: 'pointer' }}
                display={'flex'}
                flexDirection={'row'}
                className={styles.containerFooter}
                onClick={handleOnClick}
              >
                <h3 style={{ margin: '0', padding: '0' }}>{t('see')}</h3>
                <img
                  style={{ margin: '0 0 0 5px', padding: '0' }}
                  src={rightArrow}
                  alt={rightArrow}
                  className={styles.arrowRight}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}
